<template>
  <Dialog
    :open="open"
    @update:open="$emit('update:open', $event)"
    :size="maxSmall ? 'full' : undefined"
    :side="maxSmall ? 'default' : 'right'"
    :showFooter="false"
  >
    <slot />
    <template #header>
      <ProfileHeader :user="user" @editProfile="showEditProfile = true" />
    </template>
    <template #content>
      <div
        class="flex flex-col p-2 md:py-6 md:px-4 gap-2 md:gap-3 overflow-y-auto"
      >
        <ProfileBanner v-if="maxSmall" :user="user" />
        <NotificationsSection
          :buildings="buildings"
          :weeklySummaryEnabled="!!user.weekly_summary_enabled_at"
          @updateWeeklyDigest="$emit('updateWeeklyDigest', $event)"
        />
        <LanguageSection
          :user="user"
          :busy="busy"
          @updateLanguage="$emit('updateLanguage', $event)"
        />
        <SecuritySection
          :user="user"
          :errors="errors"
          :busy="busy"
          @changeEmail="$emit('changeEmail', $event)"
          @resendEmail="$emit('resendEmail')"
          @changePassword="$emit('changePassword', $event)"
          @logout="$emit('logout', $event)"
          @clearErrors="$emit('clearErrors')"
        />
      </div>
      <ProfileEdit
        v-model:open="showEditProfile"
        :user="user"
        :errors="errors"
        :busy="busy"
        @saveProfile="(data, callback) => $emit('saveProfile', data, callback)"
        @fileSelected="
          (data, callback) => $emit('fileSelected', data, callback)
        "
        @fileRemoved="$emit('fileRemoved')"
        @clearErrors="$emit('clearErrors')"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { Dialog } from "@/SharedComponents/Dialog";
import {
  ProfileHeader,
  ProfileBanner,
  LanguageSection,
  NotificationsSection,
  SecuritySection,
} from "@/SharedComponents/Profile/Partials";
import { ProfileEdit } from "@/SharedComponents/Profile/Dialogs";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

const emit = defineEmits([
  "saveProfile",
  "fileSelected",
  "fileRemoved",
  "updateWeeklyDigest",
  "updateLanguage",
  "changeEmail",
  "resendEmail",
  "changePassword",
  "logout",
  "clearErrors",
  "update:open",
]);

defineProps({
  open: { type: Boolean, default: undefined },
  buildings: { type: Array, default: () => [] },
  user: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) },
  busy: { type: Boolean, default: false },
});

const showEditProfile = ref(false);
watchEffect(() => {
  if (showEditProfile.value) {
    emit("clearErrors");
  }
});
</script>
